import {ReactElement, useState} from 'react'
import {withNamespaces, WithNamespaces, Trans} from 'react-i18next'
import Button from '@material-ui/core/Button'
import {Checkbox, FormControlLabel} from '@material-ui/core'
import {countries} from '@bdswiss/common-enums'

import messages from '../../../../assets/messages'
import {AlertDialog} from '../../../Common/Dialog'
import {useStyles} from './styles'

type ProposalAddressPopupContentProps = {
  addressProposal: {
    country?: string | null,
    line1?: string | null,
    city?: string | null,
    zip?: string | null,
    region?: string | null,
  },
  submitting: boolean,
  onClose: () => void,
  onEditClick: () => void,
  onConfirmClick: () => void,
} & WithNamespaces

function ProposalAddressPopupContentBase(props: ProposalAddressPopupContentProps): ReactElement {
  const {addressProposal, onClose, submitting, t, onEditClick, onConfirmClick} = props
  const classes = useStyles()

  const [isChecked, setIsChecked] = useState(false)

  const handleIsCheckedChange = () => setIsChecked(prevIsChecked => !prevIsChecked)

  const handleClose = () => {
    if (submitting) return

    onClose()
  }

  const countryValue = addressProposal.country
    ? Object.values(countries).find(({value}) => value === addressProposal.country)?.label
    : null

  return (
    <AlertDialog
      open
      onClose={handleClose}
      title={t(messages.confirmYourAddress.i18nKey, messages.confirmYourAddress.defaults)}
      classNames='my-bad'
    >
      <div className={classes.content}>
        <div className={classes.body}>
          <div className={classes.subTitle}><Trans {...messages.addressExtracted} /></div>
          {addressProposal.line1 ? (
            <div className={classes.row}>
              <div className={classes.label}><Trans {...messages.streetLabel} /></div>
              <div className={classes.rowValue}>{addressProposal.line1}</div>
            </div>
          ) : null}
          {addressProposal.city ? (
            <div className={classes.row}>
              <div className={classes.label}><Trans {...messages.cityLabel} /></div>
              <div className={classes.rowValue}>{addressProposal.city}</div>
            </div>
          ) : null}
          {addressProposal.zip ? (
            <div className={classes.row}>
              <div className={classes.label}><Trans {...messages.zipLabel} /></div>
              <div className={classes.rowValue}>{addressProposal.zip}</div>
            </div>
          ) : null}
          {addressProposal.region ? (
            <div className={classes.row}>
              <div className={classes.label}><Trans {...messages.regionLabel} /></div>
              <div className={classes.rowValue}>{addressProposal.region}</div>
            </div>
          ) : null}
          {countryValue ? (
            <div className={classes.row}>
              <div className={classes.label}><Trans {...messages.country} /></div>
              <div className={classes.rowValue}>{countryValue}</div>
            </div>
          ) : null}
          <div className={classes.checkboxContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isChecked}
                  onChange={handleIsCheckedChange}
                  color="primary"
                />
              }
              label={<div className={classes.checkboxLabel}><Trans {...messages.confirmAddressMatched} /></div>}
            />
          </div>
        </div>
        <div className={classes.footer}>
          <Button fullWidth disabled={submitting} color="secondary" variant="contained" onClick={onEditClick}>
            {t(messages.editManually.i18nKey, messages.editManually.defaults)}
          </Button>
          <Button fullWidth disabled={submitting || !isChecked} color="primary" variant="contained" onClick={onConfirmClick}>
            {t(messages.confirm.i18nKey, messages.confirm.defaults)}
          </Button>
        </div>
      </div>
    </AlertDialog>
  )
}

const ProposalAddressPopupContent = withNamespaces()(ProposalAddressPopupContentBase)

export {ProposalAddressPopupContent}
